<template>
  <svg
    width="210"
    height="136"
    viewBox="0 0 210 136"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="0.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#9333EA"
    />
    <rect
      x="22"
      y="8"
      width="24"
      height="24"
      rx="4"
      fill="#F4F0FA"
    />
    <path
      d="M29.5 17.5C29.5 17.2239 29.7239 17 30 17H38C38.2761 17 38.5 17.2239 38.5 17.5C38.5 17.7761 38.2761 18 38 18H30C29.7239 18 29.5 17.7761 29.5 17.5Z"
      fill="#9333EA"
    />
    <path
      d="M30.5 20C30.5 19.7239 30.7239 19.5 31 19.5H37C37.2761 19.5 37.5 19.7239 37.5 20C37.5 20.2761 37.2761 20.5 37 20.5H31C30.7239 20.5 30.5 20.2761 30.5 20Z"
      fill="#9333EA"
    />
    <path
      d="M32.5 22C32.2239 22 32 22.2239 32 22.5C32 22.7761 32.2239 23 32.5 23H35.5C35.7761 23 36 22.7761 36 22.5C36 22.2239 35.7761 22 35.5 22H32.5Z"
      fill="#9333EA"
    />
    <rect
      x="54"
      y="10"
      width="104"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="54"
      y="22"
      width="52"
      height="8"
      rx="2"
      fill="#F4F0FA"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="48.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <rect
      x="22"
      y="56"
      width="24"
      height="24"
      rx="4"
      fill="#F5F5F4"
    />
    <path
      d="M29.5 65.5C29.5 65.2239 29.7239 65 30 65H38C38.2761 65 38.5 65.2239 38.5 65.5C38.5 65.7761 38.2761 66 38 66H30C29.7239 66 29.5 65.7761 29.5 65.5Z"
      fill="#505050"
    />
    <path
      d="M30.5 68C30.5 67.7239 30.7239 67.5 31 67.5H37C37.2761 67.5 37.5 67.7239 37.5 68C37.5 68.2761 37.2761 68.5 37 68.5H31C30.7239 68.5 30.5 68.2761 30.5 68Z"
      fill="#505050"
    />
    <path
      d="M32.5 70C32.2239 70 32 70.2239 32 70.5C32 70.7761 32.2239 71 32.5 71H35.5C35.7761 71 36 70.7761 36 70.5C36 70.2239 35.7761 70 35.5 70H32.5Z"
      fill="#505050"
    />
    <rect
      x="54"
      y="58"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="70"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      fill="white"
    />
    <rect
      x="14.5"
      y="96.5"
      width="181.001"
      height="39"
      rx="2.53335"
      stroke="#E7E5E4"
    />
    <rect
      x="22"
      y="104"
      width="24"
      height="24"
      rx="4"
      fill="#F5F5F4"
    />
    <path
      d="M29.5 113.5C29.5 113.224 29.7239 113 30 113H38C38.2761 113 38.5 113.224 38.5 113.5C38.5 113.776 38.2761 114 38 114H30C29.7239 114 29.5 113.776 29.5 113.5Z"
      fill="#505050"
    />
    <path
      d="M30.5 116C30.5 115.724 30.7239 115.5 31 115.5H37C37.2761 115.5 37.5 115.724 37.5 116C37.5 116.276 37.2761 116.5 37 116.5H31C30.7239 116.5 30.5 116.276 30.5 116Z"
      fill="#505050"
    />
    <path
      d="M32.5 118C32.2239 118 32 118.224 32 118.5C32 118.776 32.2239 119 32.5 119H35.5C35.7761 119 36 118.776 36 118.5C36 118.224 35.7761 118 35.5 118H32.5Z"
      fill="#505050"
    />
    <rect
      x="54"
      y="106"
      width="104"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      x="54"
      y="118"
      width="52"
      height="8"
      rx="1.51668"
      fill="#F5F5F4"
    />
    <rect
      y="48"
      width="210"
      height="88"
      fill="url(#paint0_linear_40_11167)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_40_11167"
        x1="105"
        y1="48"
        x2="105"
        y2="136"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="white"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>
